import { Component } from '@angular/core';

@Component({
    template: `
        <dashboard class="pi-dashboard--pageNotFound">
            <ng-container dashboard-body>
                <loading-dots></loading-dots>
            </ng-container>
        </dashboard>
    `,
    styles: [],
    standalone: false
})
export class LoadingPage {}
